export enum ContractType {
  CHARTER = 0,
  SHUTTLE = 1
}
